// extracted by mini-css-extract-plugin
module.exports = {"title":"_17335","field":"_284","qrcode":"_1258"};